import React, { FC, useEffect } from 'react'
import { FormikHelpers } from 'formik'
import { push } from 'connected-react-router'

import Form from '../../components/Form'
import TermsAndConditions from '../../components/TermsAndConditions'
import CustomButton from '../../components/UI/Buttons/CustomButton'
import { signUpThunk } from '../../store/auth/thunks'
import ButtonGoogleAuth from '../../components/ButtonGoogleAuth'
import TextInput from '../../components/UI/Inputs/TextInput'
import ErrorMessage from '../../components/UI/Tooltips/ErrorMessage'

import { useDispatch, useSelector } from '../../store'
import { resetAuthErrorAction } from '../../store/auth/slice'

import { TSignupFormValues } from '../../models/form'

import '../Login/Login.scss'
import { NON_AUTH_ROUTE } from '../App/routes'

type SignupPageProps = {}

const SignupPage: FC<SignupPageProps> = () => {
  const dispatch = useDispatch()
  const { inProgress, location, error } = useSelector((state) => ({
    inProgress: state.auth.inProgress,
    location: state.router.location,
    error: state.auth.error
  }))

  const { email, name } = (location as any).query
  const extractName = name? name.split('%20'):'';
  const setUpForm = {
    initialValues: {
      name: extractName[0] ?  extractName[0]: '',
      last_name: extractName[1] ?  extractName[1]: '',
      email: email || '',
      password: '',
      password_confirmation: '',
      phone_number: '',
      company: ''
    },
    validation: 'user',
    onSubmit: async (values: TSignupFormValues, actions: FormikHelpers<TSignupFormValues>) => {
      await dispatch(signUpThunk(values))
    }
  }

  useEffect(
    () => () => {
      dispatch(resetAuthErrorAction())
    },
    [dispatch]
  )

  return (
    <div className='authentication-page'>
      <div className='authentication-page__navigation-button'>
        Already have an account?{' '}
        <CustomButton
          button='secondary'
          size='xs'
          onClick={() => dispatch(push(NON_AUTH_ROUTE.LOGIN))}
        >
          Sign In
        </CustomButton>
      </div>
      <div className='authentication-page__form'>
        <div className='authentication-page__form__title'>Create an account</div>
        <Form {...setUpForm}>
        <div className='authentication-page__wrapper'>
          <TextInput label='First Name' name='name' placeholder='First Name' />
          <TextInput label='Last Name' name='last_name' placeholder='Last Name' />
          </div>
          <TextInput
            label='Email'
            disabled={!!email}
            name='email'
            type='email'
            placeholder='Enter your email'
          />
          <TextInput
            name='password'
            label='Password'
            type='password'
            placeholder='Enter your password'
          />
          <TextInput
            name='password_confirmation'
            label='Confirm password'
            type='password'
            placeholder='Confirm your password'
          />
           <TextInput label='Phone Number' name='phone_number' placeholder='Enter your phone number' />
           <TextInput label='Company' name='company' placeholder='Enter your company name' />
          <CustomButton inProgress={inProgress} button='primary' size='big' type='submit'>
            Submit
          </CustomButton>
        </Form>
        {error && <ErrorMessage text={error.error.message} />}

        <div className='authentication-page__form__text'>or</div>
        <ButtonGoogleAuth />
      </div>
      <TermsAndConditions text={'By signing in or creating an account, you agree with our'}/>
    </div>
  )
}

export default SignupPage
